"use client"

import dynamic from "next/dynamic"

const MindscapeViewer = dynamic(
  () => import("./mindscape-viewer").then(m => ({ default: m.MindscapeViewer })),
  { ssr: false, loading: () => <div className="h-[min(70vh,600px)]" /> }
)

export function ThoughtCloudSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ backgroundColor: "var(--brand-pitch-black)" }}
    >
      <p
        className="relative z-10 pt-20 pb-8 text-center font-[var(--font-instrument-serif)] text-xl italic"
        style={{ color: "var(--brand-moon)" }}
      >
        This is what a mind looks like from the outside.
      </p>

      <div className="relative mx-auto w-[60vw] max-w-[500px]" style={{ aspectRatio: "1" }}>
        <MindscapeViewer />
      </div>

      <p
        className="relative z-10 pt-8 pb-20 text-center font-[var(--font-instrument-serif)] text-xl italic"
        style={{ color: "var(--brand-moon)" }}
      >
        Your cloud will look nothing like anyone else&apos;s.
      </p>
    </section>
  )
}
